import { render, staticRenderFns } from "./dailyWinloseSBOperatorExportFull.vue?vue&type=template&id=160fb84d&lang=pug"
import script from "./dailyWinloseSBOperatorExportFull.vue?vue&type=script&lang=js"
export * from "./dailyWinloseSBOperatorExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports